<template>
	
	<div>
		<div>
			<label>条码：</label>
			<el-input v-model="checkno"></el-input>
			<el-button @click="showrpt()">报告</el-button>
		</div>
		<div class="overall">
		 <!-- <iframe v-if="pSrc != ''" :src="pSrc" scrolling="yes" frameborder="0" wicket:id="mainPage"></iframe> -->
		<iframe ref="iframe" v-if="pSrc != ''" :src="pSrc"  width="100%" height="100%" frameborder="0" @load='loadfrom'></iframe>
		
		</div>
	 </div>
</template>

<script>
	import rpt from '../apifunction/CusReport.js'
export default {
	created(){
		this.checkno = this.$route.query.checkno;//encodeURIComponent()
		
		// this.pSrc = '/public/pdf/web/viewer.html?file=${encodeURIComponent(url)}' ;
		// alert(this.pSrc)
	},
	data() {
		return {
		  pSrc:'',
		  checkno:''
		};
	},
	methods:{
		loadfrom(){
			
			//alert(this.pSrc);
		}
	}

}
</script>

<style>
	.pdf-header{
	    height: 0.98rem;
	    width: 100%;
		background: white;
		position: fixed;
	}
	.reten{
		    width: 7rem;
		    line-height: 1rem;
		    padding: 0 0.28rem;
		    font-size: 0.3rem;
			color: #bebebe;
	}
	.router{
	    position: absolute;
	    width: 100%;
	}
/* 	.overall{
		height:80rem;
		-webkit-overflow-scrolling: touch;
		overflow-y: scroll;
		position: absolute;
		top: 0;
		right: 0;
		left: 0;

	} */
	
	.overall iframe {
			position: fixed;
			top: 0.9rem;
			bottom:1rem;
			height: 100%;
			width: 100%
			}
	
</style>
